import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TSDUploadDownloadHouseItemsData } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useTsdUploadHouseConsignmentItems = () => {
  return useMutation({
    mutationFn: async ({ tsdId, houseConsignmentIndex, file }: TSDUploadDownloadHouseItemsData) => {
      const formData = new FormData();
      if (file) {
        formData.append('file', file);

        const result = await apiClient.tsd.uploadHouseItems.mutation({
          body: formData,
          params: { tsdId, houseConsignmentIndex: houseConsignmentIndex.toString() },
        });
        return (result.body as any).data;
      }
    },
    onSuccess: () => {
      toast.success(`New house consignment items were uploaded!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error uploading the house consignment items!`);
    },
  });
};
